import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NotificationEvent } from '@interacta-shared/data-access-notification';

@Component({
    selector: 'interacta-unknown-notification',
    template: `<p>{{ notification().typeId }} - {{ notification().id }}</p>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnknownNotificationComponent {
    readonly notification = input.required<NotificationEvent>();
}
